import React from "react";
import { SvgIcon } from "@mui/material";
function PerformanceIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24">
      <svg
        id="svg"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0, 0, 400,400"
      >
        <g id="svgg">
          <path
            id="path0"
            d="M32.743 168.840 L 32.880 298.550 115.217 335.132 C 160.503 355.253,198.065 371.942,198.690 372.219 C 199.612 372.629,215.513 365.751,283.201 335.666 L 366.576 298.609 366.713 168.870 L 366.850 39.130 199.728 39.130 L 32.606 39.130 32.743 168.840 M329.887 175.136 L 329.883 274.728 264.769 303.653 L 199.656 332.578 134.610 303.669 L 69.565 274.761 69.565 175.152 L 69.565 75.543 199.728 75.543 L 329.891 75.543 329.887 175.136 M191.045 127.019 C 183.614 144.591,177.453 159.070,177.353 159.195 C 177.254 159.320,161.982 160.713,143.416 162.290 C 124.850
        163.867,109.183 165.232,108.599 165.323 C 107.834 165.443,114.900 171.857,133.930 188.315 C 148.445 200.870,160.322 211.289,160.324 211.469 C 160.325 211.649,156.796 226.930,152.481 245.426 C 148.166 263.923,144.713 279.133,144.807 279.227 C 144.901 279.321,158.358 271.316,174.711 261.438 C 191.065 251.560,204.529 243.478,204.631 243.478 C 204.734 243.478,218.192 251.561,234.538 261.439 C 250.885 271.318,264.325 279.328,264.406 279.238 C 264.488 279.149,261.035 263.930,256.734 245.419 C 252.432 226.908,248.917 211.622,248.922 211.452 C 248.927 211.281,260.789 200.870,275.281
        188.315 C 289.774 175.761,301.326 165.425,300.952 165.347 C 300.578 165.269,284.898 163.876,266.107 162.251 C 247.317 160.627,231.894 159.223,231.835 159.133 C 231.776 159.042,225.779 144.905,218.508 127.717 C 211.238 110.530,205.124 96.153,204.922 95.769 C 204.717 95.378,198.614 109.122,191.045 127.019 "
            stroke="none"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}

export default PerformanceIcon;
